import { Checkbox, styled } from "@mui/material";

export const CustomCheckbox = styled(Checkbox)({
  color: '#79767D',
  '&.Mui-checked': {
    color: '#6CA6FC',
  },
});